import React, { useContext } from 'react';

import { useParams } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';

import { AccommodationPropertyDetailsContext } from '../../context/AccommodationPropertyDetailsContext';

import AccommodationPropertyImagesPanel from './AccommodationPropertyImagesPanel';

export default function AccommodationPropertyImagesSection() {
  const { propertyId } = useParams<{ propertyId: string }>();
  const { propertyDetails } = useContext(AccommodationPropertyDetailsContext);

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">Property Images</Typography>

      <AccommodationPropertyImagesPanel propertyId={propertyId ?? ''} propertyName={propertyDetails?.name} />
    </Stack>
  );
}
